/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  CreateBusinessPartnerMutationRequest,
  CreateBusinessPartnerMutationResponse,
} from "../types/CreateBusinessPartner.ts"

export const createBusinessPartnerMutationKey = () =>
  [{ url: "/v1/contacts/create-business-partner" }] as const

export type CreateBusinessPartnerMutationKey = ReturnType<
  typeof createBusinessPartnerMutationKey
>

/**
 * @summary Create a business partner
 * {@link /v1/contacts/create-business-partner}
 */
export async function createBusinessPartner(
  data: CreateBusinessPartnerMutationRequest,
  config: Partial<RequestConfig<CreateBusinessPartnerMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateBusinessPartnerMutationResponse,
    ResponseErrorConfig<Error>,
    CreateBusinessPartnerMutationRequest
  >({
    method: "POST",
    url: `/v1/contacts/create-business-partner`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createBusinessPartnerMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateBusinessPartnerMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createBusinessPartnerMutationKey()
  return mutationOptions<
    ResponseConfig<CreateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateBusinessPartnerMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createBusinessPartner(data, config)
    },
  })
}

/**
 * @summary Create a business partner
 * {@link /v1/contacts/create-business-partner}
 */
export function useCreateBusinessPartner<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateBusinessPartnerMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateBusinessPartnerMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateBusinessPartnerMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createBusinessPartnerMutationKey()

  const baseOptions = createBusinessPartnerMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateBusinessPartnerMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateBusinessPartnerMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateBusinessPartnerMutationRequest },
    TContext
  >
}
